<template>
  <div  class="shangquanEvaluateImgPage">
      <mu-appbar class="XR-head" :title="titleTextValue">
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
    </mu-appbar>

     <div class="bannerlist" :style="{width:allWidth+'px',visibility:bannerShow}">
        <section :style="{marginTop: mTop +'px'}" class="wh_content" @touchmove="fn">
            <div :class="className" class="wh_swiper" @touchstart="s" @touchmove="m" @touchend="e">
                <template v-for="info in evaluateList.Evaluates">
                    <div class="wh_slide" @click="clickSlide" :style="{width:fullWidth+'px',height:fullHeitht +'px'}" v-for="img in info.Images" :key="img.Id">
                        <img ref="heiht" :src="img.ImgPath" />
                        <div class="evaluateInfo" v-if="titleShow">
                            <div class="evaluateDiv">
                                <div class="evaluateContent">
                                    <div class="xing-div">
                                        <span class="fa fa-star" v-for="i in info.StarLevel"></span>
                                    </div>
                                    <div class="title">
                                        {{info.ProductName}}{{info.ProductSkuAttrName?'，'+info.ProductSkuAttrName:''}}
                                    </div>
                                    <div class="content">
                                        {{info.PjContent}}
                                    </div>
                                </div>                                
                                <div class="evaluateBg"></div>
                            </div>
                        </div>
                    </div>
                </template>                
            </div>
        </section>
      </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>
<script>
    export default {      
        name :'XR-swiper',
        data() {
            return {
                fullWidth:document.documentElement.clientWidth,
                fullHeitht:document.documentElement.clientHeight-56,
                allWidth:0,
                slidesLength: 1,
                _width: 0,
                auto: true,
                slideing: true,
                timer1: '',
                className: '',
                dom: {},
                t: {
                    sx: 0,
                    s: 0,
                    m: 0,
                    e: 0
                },
                index: 1,
                mTop:0,
                banHeigth:0,
                titleTextValue:'评价列表',
                evaluateList:{},
                titleShow:true,
                bannerShow:'hidden'
            }
        },
        props: {
            //滑动所需要的时间
            autoPlay: {
                default: false
            },
            //一次滑动需要走多久
            duration: {
                default: 500
            },
            //两次滑动间隔的时间
            interval: {
                default: 2500
            },
        },
        mounted() {
            this.$refs.XRtoast.load('加载中...')
            this.getInformationDetail()
        },
        methods: {            
            GoHistory(){
                this.$router.goBack()
            },    
             clickSlide() {
                this.titleClick()
                this.$emit('click')
            },
            s(x) {
                if (this.slideing) {
                    this.clearTimeOut()
                    this.t.sx = this.getTransform()
                    this.t.s = x.touches[x.touches.length - 1].clientX
                }
            },
            m(x) {
                if (this.slideing && this.t.s != -1) {
                    this.clearTimeOut()
                    this.dom = this.dom
                    this.t.m = x.touches[x.touches.length - 1].clientX - this.t.s
                    this.setTransform(this.t.m + this.t.sx)
                }
            },
            e(x) {
                if (this.slideing && this.t.s != -1) {
                    this.clearTimeOut()
                    this.setTransform(this.t.m + this.t.sx)
                    var x = this.getTransform()
                    x += this.t.m > 0 ? this._width * 0.3 : this._width * -0.3
                    this.index = Math.round(x / this._width) * -1
                    this.wh('touch')
                }
            },
            setTransform(num) {
                this.dom.transform = `translate3d(${num}px, 0px, 0px)`
                this.dom['-webkit-transform'] = `translate3d(${num}px, 0px, 0px)`
                this.dom['-ms-transform'] = `translate3d(${num}px, 0px, 0px)`
            },
            getTransform() {
                var x = this.dom.transform || this.dom['-webkit-transform'] || this.dom['-ms-transform'];
                x = x.substring(12)
                x = x.match(/(\S*)px/)[1]
                return Number(x)
            },
            fn(e) {
                e.preventDefault()
            },
            prevSlide() {
                this.clearTimeOut()
                this.index--
                this.wh()
            },
            nextSlide() {
                this.clearTimeOut()
                this.index++
                this.wh()
            },
            slideTo(index) {
                this.clearTimeOut()
                this.index = index + 1
                this.wh()
            },
            wh(type) {
                this.slideing = false
                this.dom.transition = type == 'touch' ? '250ms' : this.duration + 'ms'
                this.setTransform(this.index * -1 * this._width)
                this.t.m = 0
                this.t.s = -1 //保证下次重新赋值
                if (this.autoPlay) {
                    this.setTime()
                }
                var timeDuration = type == 'touch' ? '250' : this.duration
                setTimeout(() => {
                    this.dom.transition = '0s'
                    if (this.index >= this.slidesLength + 1) {
                        this.index = 1
                        this.setTransform(this.index * -1 * this._width)
                    }
                    if (this.index <= 0) {
                        this.index = this.slidesLength
                        this.setTransform(this.index * -1 * this._width)
                    }
                    this.$emit('transtionend', this.index - 1)
                    this.auto = true
                    this.slideing = true
                }, timeDuration)
            },
            setTime() {
                this.timer1 = window.setTimeout(() => {
                    window.clearTimeout(this.timer1)                    
                }, this.interval)
            },
            starDom() {
                var SlideDom = document.querySelector('.' + this.className).getElementsByClassName('wh_slide')
                this.slidesLength = SlideDom.length
                var cloneDom1 = SlideDom[0].cloneNode(true) //向最后append
                var cloneDom2 = SlideDom[this.slidesLength - 1].cloneNode(true) //向最前append
                document.querySelector('.' + this.className).insertBefore(cloneDom2, SlideDom[0])
                document.querySelector('.' + this.className).appendChild(cloneDom1)
                this._width = this.fullWidth //document.querySelector('.' + this.className).offsetWidth
                this.dom = document.querySelector('.' + this.className).style
            },
            clearTimeOut() {
                this.auto = false
                window.clearTimeout(this.timer1)
            },            
            getInformationDetail(){
                var ths = this;   
                ths.$post(
                    "/Shop/StoreServer/GetShopsPhysicalEvaluateImgList",{shopId: this.$route.query.shopId,imgId:this.$route.query.imgId}
                ).then(function(res) {
                    if(!res.IsSuccess){
                    }else{          
                        ths.evaluateList = res.Data;
                        ths.loaded = false
                        for(var i = 0; i< ths.evaluateList.Evaluates.length;i++){
                            var imgEntity =ths.evaluateList.Evaluates[i]
                            if(imgEntity.Images && imgEntity.Images.length>0){
                                ths.allWidth += imgEntity.Images.length * ths.fullWidth
                            }
                        }
                        ths.allWidth += 2 * ths.fullWidth

                        ths.className = `wh_swiper_${Math.random().toFixed(3) * 1000}`
                        setTimeout(() => {
                            //克隆dom
                            ths.starDom()

                            var imgIndex = ths.evaluateList.Index
                            ths.dom.transform = `translate3d(${ths._width * - imgIndex}px, 0px, 0px)`
                            ths.dom['-webkit-transform'] = `translate3d(${ths._width * - imgIndex}px, 0px, 0px)`
                            ths.dom['-ms-transform'] = `translate3d(${ths._width * - imgIndex}px, 0px, 0px)`
                            if (ths.autoPlay) {
                                ths.setTime()
                            }

                            ths.bannerShow = 'visible'                            
                            ths.$refs.XRtoast.hide()
                        }, 50)
                        
                    }
                });
            },   
            titleClick(){
                this.titleShow = !this.titleShow
            }
        }
    }
</script>
<style>
body .shangquanEvaluateImgPage{
  background: black;
}
.shangquanEvaluateImgPage .XR-head .mu-appbar{
  height: 46px;
  text-align: center;
}
.shangquanEvaluateImgPage .XR-head .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.shangquanEvaluateImgPage .XR-head .mu-appbar-title {
  font-size: 16px;
  padding-right: 48px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.shangquanEvaluateImgPage .XR-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.shangquanEvaluateImgPage .XR-head .title .title-text {
  margin: 0;
  line-height: 48px;
}
.shangquanEvaluateImgPage .wh_content {
    position: relative;
    z-index: 1;
    overflow: hidden;
    width: 100%;
}
.shangquanEvaluateImgPage .wh_content  .wh_swiper {
    width: 100%;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    -moz-transition-duration: 0s linear;
    -webkit-transition-duration: 0s linear;
    -o-transition-duration: 0s linear;
    transition-duration: 0s linear;
}
.shangquanEvaluateImgPage  .wh_indicator {
    position: absolute;
    bottom: 10px;
    width: 100%;
    text-align: center;
    background: 0 0;
}
.shangquanEvaluateImgPage  .wh_indicator_item {
    display: inline-block;
    width: 6px;
    height: 6px;
    margin: 1px 2px;
    cursor: pointer;
    border-radius: 100%;
    background: #666;
    border:1px solid #666;
}
.shangquanEvaluateImgPage  .wh_show_bgcolor {
    background: white;
}
.shangquanEvaluateImgPage .wh_content{
    width: 100%;
}
.shangquanEvaluateImgPage .wh_content .wh_slide{
    height: 100%;
    display: flex;
    align-items:center;
    position: relative;
}
.shangquanEvaluateImgPage .wh_content .wh_slide .evaluateInfo{
    position: absolute;
    bottom: 0;
    left:0;
    right: 0;
    height: 104px;
}
.shangquanEvaluateImgPage .wh_content .wh_slide .evaluateInfo .evaluateDiv
{
    position: relative; 
    height: 104px;
}
.shangquanEvaluateImgPage .wh_content .wh_slide .evaluateInfo .evaluateDiv .evaluateContent{
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
}
.shangquanEvaluateImgPage .wh_content .wh_slide .evaluateInfo .evaluateDiv .evaluateBg{
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    background: black;
    opacity: 0.7;
    z-index: 1;
}
.shangquanEvaluateImgPage .wh_content .wh_slide .evaluateInfo .xing-div
{
    height:28px;
    overflow:hidden;
    font-size: 12px;
    padding: 10px 10px 0;
}
.shangquanEvaluateImgPage .wh_content .wh_slide .evaluateInfo .xing-div .fa
{
    color:#F10000;
    padding: 0 2px;
}
.shangquanEvaluateImgPage .wh_content .wh_slide .evaluateInfo .title
{
    line-height: 16px;
    overflow:hidden;
    color:#BFBFBF;
    font-size: 12px;
    padding: 4px 10px 10px;
}
.shangquanEvaluateImgPage .wh_content .wh_slide .evaluateInfo .content
{
    height:46px;
    line-height: 18px;
    overflow:hidden;
    color:white;
    font-size: 12px;
    padding: 0 10px 10px;
}

.shangquanEvaluateImgPage .wh_content .wh_slide img{
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/shangquan/sqEvaluateImg.vue